/**
 * Vanilla JavaScript navbar functionality
 * Handles mobile menu toggle without Bootstrap
 */

document.addEventListener("DOMContentLoaded", function () {
	const navbarCollapse = document.getElementById("navbarNav");
	const navbarToggler = document.querySelector(".navbar-toggler");
	const navbar = document.querySelector(".navbar");

	// SEARCH BAR TOGGLE - Function to initialize search functionality
	function initSearchToggle(container = document) {
		const searchToggle = container.querySelector(".search-toggle");
		const searchFormWrapper = container.querySelector(
			".search-form-wrapper"
		);

		if (searchToggle && searchFormWrapper) {
			// Remove existing listeners by cloning
			const newSearchToggle = searchToggle.cloneNode(true);
			searchToggle.parentNode.replaceChild(newSearchToggle, searchToggle);

			newSearchToggle.addEventListener("click", function (e) {
				e.preventDefault();
				e.stopPropagation();
				searchFormWrapper.classList.toggle("active");
			});

			// Close search when clicking outside
			const closeSearchHandler = function (e) {
				const searchBar = container.querySelector(".search-bar");
				if (searchBar && !searchBar.contains(e.target)) {
					searchFormWrapper.classList.remove("active");
				}
			};

			document.removeEventListener("click", closeSearchHandler);
			document.addEventListener("click", closeSearchHandler);
		}
	}

	// Initialize search for main navbar
	initSearchToggle();

	if (navbarCollapse && navbarToggler && navbar) {
		// Toggle menu function
		function toggleMenu() {
			const isOpen = navbarCollapse.classList.contains("show");

			if (isOpen) {
				closeMenu();
			} else {
				openMenu();
			}
		}

		// Open menu function
		function openMenu() {
			navbarCollapse.classList.add("show");
			navbarToggler.setAttribute("aria-expanded", "true");
			navbar.classList.add("active");
			closeButton.style.display = "block";
		}

		// Close menu function
		function closeMenu() {
			navbarCollapse.classList.remove("show");
			navbarToggler.setAttribute("aria-expanded", "false");
			navbar.classList.remove("active");
			closeButton.style.display = "none";
		}

		// Handle burger button click and touch events
		let touchStarted = false;
		let lastAction = 0;

		function handleMenuToggle(e) {
			const now = Date.now();
			if (now - lastAction < 300) return; // Prevent double triggers

			e.preventDefault();
			e.stopPropagation();
			toggleMenu();
			lastAction = now;
		}

		navbarToggler.addEventListener(
			"touchstart",
			function (e) {
				touchStarted = true;
			},
			{ passive: false }
		);

		navbarToggler.addEventListener(
			"touchend",
			function (e) {
				if (touchStarted) {
					handleMenuToggle(e);
					touchStarted = false;
				}
			},
			{ passive: false }
		);

		navbarToggler.addEventListener("click", function (e) {
			if (!touchStarted) {
				handleMenuToggle(e);
			}
		});

		// Create close button
		const closeButton = document.createElement("button");
		closeButton.className = "navbar-close-btn";
		closeButton.setAttribute("aria-label", "Close navigation menu");
		closeButton.style.cssText = `
      position: absolute;
      top: 2rem;
      left: 2rem;
      width: 4rem;
      height: 4rem;
      background: transparent;
      border: none;
      cursor: pointer;
      z-index: 1052;
      display: none;
      touch-action: manipulation;
      -webkit-tap-highlight-color: transparent;
    `;

		// Add the close button to the navbar collapse
		navbarCollapse.appendChild(closeButton);

		// Handle close button click
		closeButton.addEventListener("click", function (e) {
			e.preventDefault();
			e.stopPropagation();
			closeMenu();
		});

		// MOBILE SUBMENU TOGGLE
		function initMobileSubmenus() {
			const dropdownToggles =
				navbarCollapse.querySelectorAll(".dropdown-toggle");

			dropdownToggles.forEach((toggle) => {
				// Créer le bouton toggle pour mobile
				const toggleBtn = document.createElement("button");
				toggleBtn.className = "mobile-submenu-toggle";
				toggleBtn.setAttribute("aria-label", "Toggle submenu");
				toggleBtn.innerHTML =
					'<svg width="22" height="12" viewBox="0 0 22 12" fill="none"><path d="M21 11L11 1L1 11" stroke="#002B5C" stroke-opacity="0.8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

				// Insérer le bouton après le lien
				toggle.parentElement.style.position = "relative";
				toggle.parentElement.appendChild(toggleBtn);

				// Empêcher le lien parent de naviguer EN MOBILE
				// toggle.addEventListener("click", function (e) {
				// 	if (window.innerWidth < 1200) {
				// 		// < bm__xl
				// 		e.preventDefault();
				// 		toggleSubmenu(this);
				// 	}
				// });

				// Le bouton toggle ouvre/ferme le sous-menu
				toggleBtn.addEventListener("click", function (e) {
					e.preventDefault();
					e.stopPropagation();
					toggleSubmenu(toggle);
				});
			});
		}

		function toggleSubmenu(toggleElement) {
			const submenu = toggleElement.nextElementSibling;
			const parentItem = toggleElement.parentElement;
			const toggleBtn = parentItem.querySelector(
				".mobile-submenu-toggle"
			);

			if (submenu && submenu.classList.contains("dropdown-menu")) {
				const isOpen = submenu.classList.contains("show");

				// Fermer tous les autres sous-menus
				document
					.querySelectorAll(".dropdown-menu.show")
					.forEach((menu) => {
						if (menu !== submenu) {
							menu.classList.remove("show");
							menu.parentElement.classList.remove("active");
							const otherBtn = menu.parentElement.querySelector(
								".mobile-submenu-toggle"
							);
							if (otherBtn) otherBtn.classList.remove("active");
						}
					});

				// Toggle le sous-menu actuel
				if (isOpen) {
					submenu.classList.remove("show");
					parentItem.classList.remove("active");
					if (toggleBtn) toggleBtn.classList.remove("active");
				} else {
					submenu.classList.add("show");
					parentItem.classList.add("active");
					if (toggleBtn) toggleBtn.classList.add("active");
				}
			}
		}

		// Initialiser les sous-menus mobiles
		initMobileSubmenus();

		// Close menu when clicking on nav links (sauf dropdown-toggle)
		const navLinks = navbarCollapse.querySelectorAll(
			".nav-link:not(.dropdown-toggle)"
		);
		navLinks.forEach((link) => {
			link.addEventListener("click", function () {
				// Close the menu after a small delay to allow navigation
				setTimeout(() => {
					closeMenu();
				}, 150);
			});
		});

		// Close menu when clicking outside
		document.addEventListener("click", function (e) {
			if (
				!navbar.contains(e.target) &&
				navbarCollapse.classList.contains("show")
			) {
				closeMenu();
			}
		});
	}

	// NAVBAR ANIMATION - SEULEMENT DESKTOP (>991px)
	const nav = document.getElementById("main-nav");
	let fixedNav = null;

	function isDesktop() {
		return window.innerWidth >= 1200; // bm__xl breakpoint
	}

	function isHomepage() {
		return document.body.classList.contains("home");
	}

	window.addEventListener("scroll", () => {
		const scroll = window.pageYOffset;

		// Ne pas créer l'animation sur mobile/tablet
		if (!isDesktop()) {
			if (fixedNav) {
				fixedNav.remove();
				fixedNav = null;
			}
			return;
		}

		if (scroll > 150 && !fixedNav) {
			// CRÉER LE NAVBAR FIXE
			// Supprimer la popup avant de cloner pour éviter les doublons
			const popupToRemove = nav.querySelector(
				'.search-results-popup[data-no-clone="true"]'
			);
			if (popupToRemove) {
				popupToRemove.remove();
			}

			fixedNav = nav.cloneNode(true);
			fixedNav.id = "fixed-navbar";
			fixedNav.classList.add("fixed"); // Classe pour styling CSS

			// Remettre la popup dans le navbar original
			if (popupToRemove) {
				const originalNavCtnr = nav.querySelector(".nav-ctnr");
				if (originalNavCtnr) {
					originalNavCtnr.appendChild(popupToRemove);
				}
			}

			// Sur la homepage, forcer le layout horizontal pour le navbar fixe
			if (isHomepage()) {
				fixedNav.setAttribute("data-fixed-homepage", "true");
			}

			// STYLES DIRECTS
			Object.assign(fixedNav.style, {
				position: "fixed",
				top: "-100px", // Commencer caché en haut
				left: "0",
				width: "100%",
				zIndex: "9999",
				transition: "top 0.3s ease",
			});

			document.body.appendChild(fixedNav);

			// Initialize search toggle for the fixed navbar
			initSearchToggle(fixedNav);

			// ANIMATION : descendre à top: 0
			setTimeout(() => {
				fixedNav.style.top = "0px";
			}, 10);
		} else if (scroll <= 150 && fixedNav) {
			// SUPPRIMER LE NAVBAR FIXE
			fixedNav.style.top = "-100px";
			setTimeout(() => {
				if (fixedNav) {
					fixedNav.remove();
					fixedNav = null;
				}
			}, 300);
		}
	});

	// Nettoyer l'animation si on redimensionne vers mobile
	window.addEventListener("resize", () => {
		if (!isDesktop() && fixedNav) {
			fixedNav.remove();
			fixedNav = null;
		}
	});
});
